<template>
  <div class="wrapper">
    <!-- <div class="top">
      <router-link to="/">
        <div class="logo">
          <img src="~@/assets/image/logo.png" alt>
        </div>
      </router-link>
      
    </div> -->
    <div class="m">
      <div class="container">
        <div class="login-form-wrap">
          <div class="login-form">
            <div class="tabs">
              <div class="tab" :class="{active:loginType==0}" @click="loginType=0">账号登录</div>
              <div class="tab" :class="{active:loginType==1}" @click="loginType=1">验证码登录</div>
            </div>
            <div v-show="loginType==0">
              <input-group icon="icontel" placeholder="请输入手机号或账号" v-model="telphone"></input-group>
              <input-group
                icon="iconpassword"
                placeholder="请输入密码"
                v-model="password"
                :type="showPassword?'text':'password'"
                @keyup.enter.native="loginAjax"
              >
                <i
                  class="icon iconfont"
                  :class="showPassword?'iconpassword-view':' iconpassword-not-view'"
                  @click="changeInputType"
                ></i>
              </input-group>
              <div class="login-item" v-if="isCaptcha">
                <input-group class="login-item-input" placeholder-class="login-item-i-p fsz26" type="text" v-model="captcha" placeholder="输入验证码" style="width: 100%" ></input-group>
                <img class="codeimg" :src="captchaUrl" alt="" @click="getCodeImg" />
              </div>
            </div>
            <div v-show="loginType==1">
              <code-input
                @getTelPhone="getPhoneValue"
                @getInputError="getInputError"
                @getSmsCode="getSmsCode"
              ></code-input>
            </div>
            <div class="error" v-show="showError">
              <i class="icon iconfont iconerror"></i>
              {{errorText}}
            </div>
            <div class="login-btn" @click="loginAjax">登录</div>
            <div class="tip">
              <router-link to="register">立即注册</router-link>
              <!-- <a href>忘记密码</a> -->
            </div>
            <!-- <div class="fast">
              <div class="intro">快速登录</div>
              <div class="login-type">
                <div class="type-item">
                  <i class="icon iconfont iconqq"></i>
                </div>
                <div class="type-item">
                  <i class="icon iconfont iconweixin"></i>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <CopyRight></CopyRight>
  </div>
</template>

<script>
import LoginInputGroup from "@/components/login/LoginInputGroup.vue";
import InputGroup from "@/components/layout/InputGroup.vue";
import CopyRight from "@/components/common/CopyRight.vue";
import { 
  // inputCheckPhone,
  isValid 
} from "@/utils/index.js";
import { mapActions } from "vuex";
import { apiBaseUrl } from '@/config/env.js'
export default {
  name: "Login",
  components: {
    "code-input": LoginInputGroup,
    "input-group": InputGroup,
    CopyRight
  },
  props: {},
  data() {
    return {
      telphone: "",
      password: "",
      smsCode: "",
      checked: true,
      loginType: 0,
      errorText: "",
      showPassword: false,
      isCaptcha: false, // 是否需要验证码
      captcha: '', // 输入的验证码
      captchaUrl: '', // 验证码图片地址
    };
  },
  watch: {},
  computed: {
    showError() {
      return isValid(this.errorText);
    }
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    loginAjax() {
      if (this.loginType == 0) {
        this.passwordToLogin();
      } else {
        this.smsCodeLogin();
      }
    },
    changeInputType() {
      this.showPassword = !this.showPassword;
    },
    checkInputPhone() {
      if (!isValid(this.telphone)) {
        this.errorText = "手机号或账号不能为空";
        return false;
      } 
      // else if (!inputCheckPhone(this.telphone)) {
      //   this.errorText = "手机号格式不正确";
      //   return false;
      // }
      this.errorText = "";
      return true;
    },
    checkInputPassword() {
      if (!isValid(this.password)) {
        this.errorText = "请输入密码";
        return false;
      }
      return true;
    },
    checkInputCode() {
      if (!isValid(this.smsCode)) {
        this.errorText = "请输入验证码";
        return false;
      }
      return true;
    },
    smsCodeLogin() {
      if (this.checkInputPhone() && this.checkInputCode()) {
        let data = {
          mobile: this.telphone,
          code: this.smsCode,
          platform: 5
        };
        let _this = this;
        this.$api.smsLogin(data).then(res => {
          if (res.status) {
            _this.$storage.set("timer", 0);
            _this.$storage.set("userToken", res.data);
            _this.$api.userInfo({}).then(result => {
              if (result.status) {
                _this.getUserInfo(result.data);
                _this.$storage.set("userInfo", result.data);
              }
            });
			console.log("_this.$router.go",_this.$router);
            _this.$router.go(-1);
          } else {
            _this.errorText = res.msg;
          }
        });
      }
    },
    passwordToLogin() {
      if (this.checkInputPhone() && this.checkInputPassword()) {
        let data={
          mobile:this.telphone,
          password:this.password,
          platform:5
        }
        if(this.isCaptcha){
          data.captcha=this.captcha
        }
        let _this = this;
        this.$api.login(data).then(res => {
          if (res.status) {
            _this.$storage.set("userToken", res.data);
            _this.$api.userInfo({}).then(result => {
              if (result.status) {
                _this.getUserInfo(result.data);
                _this.$storage.set("userInfo", result.data);
              }
            });
            //_this.$router.push("home");
			_this.$router.go(-1);
          } else {
            _this.errorText = res.msg;
            // 需要输入验证码 或者 验证码错误刷新
            if (res.data === 10013 || res.data === 10012) {
              _this.isCaptcha = true
            }
            // 登录需要验证码
            if (_this.isCaptcha) {
              _this.getCaptchaUrl()
            }
          }
        });
      }
    },
      // 获取验证码图片地址
    getCaptchaUrl() {
      this.captchaUrl = apiBaseUrl + 'captcha.html'
    },
    getCodeImg() {
      let num = Math.ceil(Math.random() * 1000)
      this.captchaUrl = apiBaseUrl + 'captcha.html?' + num
    },
    //获取子组件手机号
    getPhoneValue(val) {
      this.telphone = val;
    },
    //获取子组件验证码
    getSmsCode(val) {
      this.smsCode = val;
    },
    //获取错位信息
    getInputError(val) {
      this.errorText = val;
    }
  },
  created() {},
  mounted() {
    if (this.$storage.get("userToken")) {
      this.$router.replace("/");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.wrapper {
  width: 100%;
  height: 100%;
  background: #fff;
  .top {
    height: 100px;
    background: #fff;
    position: relative;
    .logo {
     
      position: absolute;
      top: 40px;
      left: 200px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .welecome {
      width: 100px;
      height: 40px;
      line-height: 40px;
      position: absolute;
      top: 40px;
      left: 300px;
      font-size: 20px;
    }
  }
  .m {
    width: 100%;
    height: 900px;
    background: url(~@/assets/image/logomain.jpg)
      no-repeat center;
    background-size: cover;
    // background: $theme-bg;
    .container {
      width: 1226px;
      height: 100%;
      position: relative;
      margin: 0 auto;
      .login-form-wrap {
        position: absolute;
        right: 0;
        top: 50%;
        width: 320px;
        height: 410px;
        margin-top: -205px;
        background: #fff;
        padding: 23px;
        box-sizing: border-box;
        .login-form {
          position: relative;
          height: 100%;
          .tabs {
            margin: 20px auto;
            display: flex;
            justify-content: space-around;
            .tab {
              text-align: center;
              flex: 1;
              cursor: pointer;
              &:first-of-type {
                border-right: 1px solid #373131;
              }
              &.active {
                color: $theme-color;
              }
            }
          }
          .error {
            font-size: 12px;
            color: $theme-color;
            transition: all 0.2s;
          }
          .login-btn {
            width: 100%;
            height: 40px;
            line-height: 40px;
            background: $theme-color;
            color: #fff;
            font-size: 12px;
            text-align: center;
            cursor: pointer;
            margin-top: 20px;
          }
          .tip {
            text-align: right;
            margin: 5px 0 60px;
            a {
              display: inline-block;
              color: #666666;
              padding: 0 6px;
              font-size: 10px;
              &:not(:last-of-type) {
                border-right: 1px solid #e0e0e0;
              }
              &:hover {
                color: $theme-color;
              }
            }
          }
          .fast {
            position: absolute;
            width: 100%;
            bottom: 15px;
            left: 0;
            .intro {
              text-align: center;
              width: 50px;
              height: 20px;
              margin: 0 auto 20px;
              font-size: 12px;
              line-height: 20px;
              position: relative;
              &:before {
                content: "";
                position: absolute;
                left: -50px;
                top: 9px;
                width: 40px;
                height: 1px;
                background: #ccc;
              }
              &:after {
                content: "";
                position: absolute;
                right: -50px;
                top: 9px;
                width: 40px;
                height: 1px;
                background: #ccc;
              }
            }
            .login-type {
              display: flex;
              justify-content: center;
              .type-item {
                width: 24px;
                height: 24px;
                border-radius: 50%;
                padding: 4px;
                cursor: pointer;
                margin: 0 20px;
                .icon {
                  font-size: 24px;
                }
                .iconqq,
                .iconzhifubao {
                  color: #1296db;
                }
                .iconweixin {
                  color: #1afa29;
                }
              }
            }
          }
        }
      }
    }
  }
}
.copyright-wrap {
  background: $theme-bg;
}
.login-item{
  position: relative;
}
.codeimg{
  width: 100%;
  height: 38px;
  position: absolute;
  top: 1px;
  right: 1px;
  width: 150px;
}
</style>